import { createReducer, on } from '@ngrx/store';
import * as ReportActions from './report-analysis.actions';
import { ReportAnalysis } from './report-analysis.model';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface ReportAnalysisState {
    Report: ReportAnalysis | null;
    isLoading: boolean;
    isAvailable: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialReportAnalysisState: ReportAnalysisState = {
    Report: null,
    isLoading: false,
    isAvailable: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// Report
export const reportAnalysisReducer = createReducer(
    initialReportAnalysisState,

    // On generate report
    on(ReportActions.generateInventorySalesAnalysisReport, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ReportActions.generateInventorySalesAnalysisReportSuccess,
        (state, { report }) => ({
            ...state,
            isLoading: false,
            isAvailable: true,
            Report: report,
        })
    ),
    on(
        ReportActions.generateInventorySalesAnalysisReportFailure,
        (state, { error }) => ({
            ...state,
            isLoading: false,
            isAvailable: false,
            error: error,
        })
    ),

    // Clear
    on(ReportActions.clearPreviousAnalysisReport, (state) => ({
        ...state,
        isLoading: false,
        isAvailable: false,
        Report: null,
    }))
);
